import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { APP_TYPE, LocaleCode } from '../../enums';
import { LanguageService } from '../../services';
import { APP_CONTEXT } from '../../utils/app-context';

@Component({
  selector: 'lib-signin-layout',
  templateUrl: './signin-layout.component.html',
  styleUrls: ['./signin-layout.component.scss'],
  standalone: true,
  imports: [RouterOutlet, ButtonModule, TranslateModule],
})
export class SigninLayoutComponent {
  private readonly languageService = inject(LanguageService);

  private readonly currentLanguage = toSignal(this.languageService.currentLanguage$);

  public readonly appMode = inject(APP_CONTEXT);

  appType = APP_TYPE;

  readonly targetLanguageLabel = computed(() => {
    return this.currentLanguage()?.locale === LocaleCode.FA ? 'EN' : 'فا';
  });

  toggleLanguage() {
    const current = this.languageService.getCurrentLanguage().locale;
    const target = current === LocaleCode.FA ? LocaleCode.EN : LocaleCode.FA;
    
    this.languageService.setLanguage(target).subscribe(); 
  }
}
